import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface IGamificationMainState {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  status: 'onboarding' | 'playing' | 'notPlaying' | 'finishingWeek' | 'yearReview';
  setStatus: (status: 'playing' | 'notPlaying' | 'finishingWeek' | 'yearReview') => void;
  selectedTab: string;
  userBadges: any[];
  setUserBadges: (badges: any[]) => void;
  userSummary: any | null;
  setUserSummary: (summary: any) => void;
  setSelectedTab: (tab: string) => void;
}

export const useGamificationMainStore = create(
  persist<IGamificationMainState>(
    (set) => ({
      isOpen: false,
      setIsOpen: (open: boolean) => set({ isOpen: open }),

      userBadges: [],
      setUserBadges: (badges: any[]) => set({ userBadges: badges }),

      userSummary: null,
      setUserSummary: (summary: any) => set({ userSummary: summary, status: summary.status }),

      status: 'onboarding',
      setStatus: (status) => set({ status }),

      selectedTab: 'playing',
      setSelectedTab: (tab: string) => set({ selectedTab: tab }),
    }),
    {
      name: 'gamification-main-store', // nome da key no localStorage
    }
  )
);
